export const SELECTED_TICKET_PREFIX = 'ST-';
export const TICKET_PROPS_SEPARATOR = '.';
export const TICKET_PROPS_WRAPPER_OPEN = '(';
export const TICKET_PROPS_WRAPPER_CLOSE = ')';
export const ACTIVITY_TICKETS_SEPARATOR = ':';
export const ACTIVITY_PROPS_SEPARATOR = ':';
